import CustomSlider from '@components/CustomSlider/CustomSlider';
import styles from './AdditionalSliceContent.module.scss'
import Button from '@components/Button';
import { WheelEvent } from 'react';

export interface AdditionalSliceContentProps {
  value: number;
  onChangeValue: (val: number) => void;
  onReset: ()=>void;
  onClose: () => void;
  min?: number;
  max?: number;
  step?: number;
}

const AdditionalSliceContent: React.FC<AdditionalSliceContentProps> = ({
  value,
  onChangeValue,
  onReset,
  onClose,
  min = -150.0,
  max = 50.0,
  step = 1.0,
}) => {
  return (
    <div className={styles['Container']}>
      <div className={styles['Box1']}>
        Additional Slice
        <Button
          className={styles.resetButton}
          onClick={onReset}
        >
          Reset
        </Button>
      </div>
      <div className={styles['Box2']}
      onWheel={(e:WheelEvent)=>{
        if (e.deltaY === 0) return;
        const newVal = Math.min(max,Math.max(min,value+Math.sign(-e.deltaY)));
        onChangeValue(newVal);
      }}
      >
        <CustomSlider
          type="default"
          value={value}
          onChange={onChangeValue}
          min={min}
          max={max}
          step={step}
        />
        <div className={styles['value']}>
          {value}
        </div>
      </div>
    </div>
  )
}

export default AdditionalSliceContent;
